

const definitions = {
    something: {
        points: [
            [0, 0],
            [0, 1],
            [1, 1],
            [1, 0],
            [-1, 0],
            [-1, 1]
        ],
        edges: [
            [0, 1],
            [0, 2],
            [1, 2],
            [1, 3],
            [2, 3],
            [1, 4],
            [4, 5],
            [0, 5],
            [1, 5]
        ]
    },
    circle: {
        points: [
            [0, 0],
            [-0.707, 0.293],
            [-1, 1],
            [-0.707, 1.707],
            [0, 2],
            [0.707, 1.707],
            [1, 1],
            [0.707, 0.293],
            [0, 1]
        ],
        edges: [
            [0, 1],
            [1, 2],
            [2, 3],
            [3, 4],
            [4, 5],
            [5, 6],
            [6, 7],
            [7, 0],
            [0, 8],
            [1, 8],
            [2, 8],
            [3, 8],
            [4, 8],
            [5, 8],
            [6, 8],
            [7, 8]
        ]
    },
    rojas: {
        points: [
            [0, 0],
            [-.8, .4],
            [-.1, 1],
            [.7, 1.2],
            [1.6, .4],
            [2, .95],
            [2.3, 0],
            [2.7, .4],
            [3, 0]
        ],
        edges: [
            [0, 1],
            [0, 2],
            [0, 4],
            [1, 2],
            [2, 3],
            [2, 4],
            [3, 4],
            [3, 5],
            [4, 5],
            [4, 6],
            [4, 7],
            [5, 7],
            [6, 7],
            [6, 8],
            [7, 8],
        ]
    }
};
export default definitions;



//////////////////
// WEBPACK FOOTER
// ./js/simulator/creatureDefinitions.js
// module id = 152
// module chunks = 0